import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials sends the HttpOnly `calibrate_auth` cookie with every
// API call. Auth state now lives server-side in that cookie; localStorage
// is only used to cache the user profile object for a snappy first paint.
export const api = axios.create({ baseURL: API, withCredentials: true });

// Turn any axios error into a human-readable string.
// Handles FastAPI's `detail: [{msg, loc, ...}]` validation error shape.
export function apiError(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") {
    // Strip our discriminator prefixes used for branching in callers
    return d.replace(/^EMAIL_NOT_VERIFIED:\s*/, "");
  }
  if (Array.isArray(d) && d.length) {
    const first = d[0];
    if (typeof first === "string") return first;
    if (first?.msg) return first.msg.replace(/^Value error,\s*/i, "");
  }
  if (err?.message) return err.message;
  return fallback;
}

// Transition helper: any legacy Bearer token still sitting in localStorage
// (from before the HttpOnly-cookie migration) is sent as a fallback so the
// user isn't kicked out mid-session. New sessions ignore localStorage.
api.interceptors.request.use((config) => {
  const legacy = localStorage.getItem("calibrate_token");
  if (legacy && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${legacy}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("calibrate_token");
      localStorage.removeItem("calibrate_user");
      // Skip the auto-redirect when the failing call is our own auth probe.
      // AuthProvider mounts /auth/me on every page load — including public
      // routes like /pricing and /terms — so a 401 here just means "no
      // active session"; the provider handles it by setting user=null. If
      // we redirect here, public pages become inaccessible for logged-out
      // visitors.
      const url = err.config?.url || "";
      const isAuthProbe = url.endsWith("/auth/me");
      if (!isAuthProbe
          && !window.location.pathname.startsWith("/login")
          && !window.location.pathname.startsWith("/register")
          && window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
